export const navConfig = {
  orchestrator: [
    {
      label: "Overview",
      to: "/Overvaagning",
      match: (path) => path === "/Overvaagning",
    },
    {
      label: "Jobs",
      to: "/Automationer/Jobs",
      match: (path) => path.includes("/Automationer/Jobs"),
    },
    {
      label: "Processes",
      to: "/Automationer/Processer",
      match: (path) => path.includes("/Automationer/Processer"),
    },
    //{ label: 'Triggers', to: '/Automationer/Trigger', match: path => path.includes('/Automationer/Trigger') },
  ],
  analytics: [
    {
      label: "Business",
      to: "/Analytics/Business",
      match: (path) => path.includes("/Analytics/Business"),
    },
    {
      label: "Operations",
      to: "/Analytics/Operations",
      match: (path) => path.includes("/Analytics/Operations"),
    },
    {
      label: "Settings",
      to: "/Analytics/Settings",
      match: (path) => path.includes("/Analytics/Settings"),
    }
  ],
  etl: [
    {
      label: "Connections",
      to: "/ETL/connections",
      match: (path) => path.includes("/ETL/connections"),
    },
    {
      label: "Pipelines",
      to: "/ETL/pipelines",
      match: (path) => path.includes("/ETL/pipelines"),
    },
    {
      label: "Data",
      to: "/ETL/data",
      match: (path) => path === "/ETL/data",
    },
  ],
};

export const defaultRoutes = {
  orchestrator: "/Overvaagning",
  analytics: "/Analytics/Business",
  etl: "/ETL/connections",
};
